/* eslint-disable @typescript-eslint/no-unused-vars */
import "PFCore/profinda";

import { enableMapSet } from "immer";
import ReactApp from "PFApp/react_app";
import { applyUrlConfig } from "PFCore/initializers/apply_url_config";
import { customizeConfig } from "PFCore/initializers/customize_config";
import ReactDOM from "react-dom/client";

import i18n from "./i18n";

enableMapSet();

window.PF.Initializers.customizeConfig = customizeConfig;

const renderApp = () => {
  const reactAppElement = document.getElementById("react_app");
  if (!reactAppElement) {
    return;
  }
  const root = ReactDOM.createRoot(reactAppElement);
  root.render(<ReactApp />);
};

if (!applyUrlConfig()) {
  if (document.readyState !== "loading") {
    renderApp();
  } else {
    document.addEventListener("DOMContentLoaded", renderApp, false);
  }
}
